<template>
  <div class="account-balance">
    <router-link class="d-flex flex-md-column justify-content-md-center justify-content-xl-start flex-xl-row" :to="{path:'/account/invoices'}">
      {{ $t('Account Balance:') }}
      <span :class="['account-balance__amount', 'ml-xl-1', {'account-balance__amount--negative': negativeBalance}]">
        {{ $n(absoluteAmount, 'currency') }} <small class="vat-text">{{ $t('accountBalance.vat') }}</small>
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AccountBalance",
  computed: {
    amount: function() {
      return this.$store.state.company.ACCOUNT_BALANCE;
    },
    negativeBalance: function() {
      return this.amount > 0;
    },
    absoluteAmount: function() {
      return Math.abs(this.amount);
    }
  }
}
</script>

<style scoped lang="scss">

  .navbar-light {
    .navbar-text {
      a,
      a:focus,
      a:hover{
        color: $white;
      }
    }
  }

  .account-balance {
    &__amount {
      font-weight: $font-weight-bold;
      color: $white;

      &--negative {
        color: $danger;
      }
    }
  }
</style>
